/**
 * Kategori simgeleri — adres ÇÖZÜMÜ.
 *
 * Görseller `public/` altında DEĞİL `src/assets/` altında duruyor çünkü
 * Vite oradakileri parmak izleyip adına içerik hash'i koyuyor. `public/`
 * altında adres sabit kalıyordu ve nginx bu uzantılara `immutable, 1 yıl`
 * veriyor → dosya değişse bile Cloudflare bir yıl boyunca ESKİSİNİ sunuyor
 * (menü şablonlarında bir kez yaşandı, 20 Eki 2026).
 *
 * Haritanın anahtarı DB'deki simge adı; sunucu da aynı listeyi beyaz liste
 * olarak tutuyor (apps/api/src/utils/categoryIcons.js).
 */
const MAP = import.meta.glob('./assets/cat/*.png', { eager: true, import: 'default' });

export const CATEGORY_ICONS = [
  'soup', 'main', 'grill', 'kebab', 'pide', 'oven', 'greens', 'dessert', 'drink', 'coffee',
];

/** Simge adı → paketlenmiş adres. Bilinmeyen ad `null` döner (ekran çökmez). */
export const catIconUrl = (name) => (name ? MAP[`./assets/cat/${name}.png`] || null : null);
